import { attr, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Partnership = ApplicationRecord.extend({
  attrs: {
    name: attr({ persist: false }),
    partnership_customers: hasMany({ type: 'partnerships-partnership_customers' }),
  },
  static: {
    endpoint: '/partnerships',
    jsonapiType: 'partnerships-partnerships',
  },
});

export default Partnership;
